if (!customElements.get('card-slider')) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      if (this.classList.contains('js-testimonials')) {
        window.addEventListener('resize', () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider.params.effect === 'slide';

          if (isMobile && !isSlideEffect || !isMobile && isSlideEffect) {
            this.reInitSlider(swiperOptions);
          }
        });
      }
    }

    reInitSlider(swiperOptions) {
      this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      // Create unique IDs for this carousel instance
      const carouselId = `carousel-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      this.setAttribute('data-carousel-id', carouselId);
      
      // Find navigation buttons - try multiple approaches
      let nextBtn = this.querySelector('.swiper-button--next');
      let prevBtn = this.querySelector('.swiper-button--prev');
      
      // If not found inside, try parent section
      if (!nextBtn || !prevBtn) {
        const section = this.closest('section') || this.closest('[data-section-id]');
        if (section) {
          nextBtn = nextBtn || section.querySelector('.swiper-button--next');
          prevBtn = prevBtn || section.querySelector('.swiper-button--prev');
        }
      }
      
      // Only assign to this carousel if buttons are not already assigned to another carousel
      if (nextBtn && !nextBtn.hasAttribute('data-carousel-id')) {
        nextBtn.setAttribute('data-carousel-id', carouselId);
        nextBtn.id = `next-${carouselId}`;
      }
      if (prevBtn && !prevBtn.hasAttribute('data-carousel-id')) {
        prevBtn.setAttribute('data-carousel-id', carouselId);
        prevBtn.id = `prev-${carouselId}`;
      }

      let sliderOptions = {
        slidesPerView: 'auto',
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        resistanceRatio: 0.72,
        navigation: {
          nextEl: (nextBtn && nextBtn.getAttribute('data-carousel-id') === carouselId) ? `#next-${carouselId}` : null,
          prevEl: (prevBtn && prevBtn.getAttribute('data-carousel-id') === carouselId) ? `#prev-${carouselId}` : null,
        },
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
          }
        }
      };

      const isArticlesSlider = this.classList.contains('js-articles');

      if (isArticlesSlider) {
        sliderOptions.breakpoints[575] = {
          slidesPerView: 2,
        };
      } else if (this.classList.contains('js-testimonials')) {
        if (window.innerWidth < mobileWidth) {
          sliderOptions.spaceBetween = 4;
          sliderOptions.breakpoints[480] = {
            slidesPerView: 2
          };
          sliderOptions.breakpoints[750].slidesPerView = 1;
        } else {
          sliderOptions = {
            effect: 'fade',
            slidesPerView: 1,
            rewind: true,
            followFinger: false,
            navigation: {
              nextEl: (nextBtn && nextBtn.getAttribute('data-carousel-id') === carouselId) ? `#next-${carouselId}` : null,
              prevEl: (prevBtn && prevBtn.getAttribute('data-carousel-id') === carouselId) ? `#prev-${carouselId}` : null,
            },
          };
        }

      }

      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define('card-slider', CardSlider);
}
